export default {
  computed: {
    domain() {
      return window.location.origin
    },
  },
}
